import _find from 'lodash/find';
import _remove from 'lodash/remove';
import viewTalkTemplate from './view-talk/view-talk.html';
import template from './talks.html';

class TalksComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    TalkService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.TalkService = TalkService;
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.talks) {
      this.talks = Object.assign([], this.talks);
    }
  }

  view(id, ev) {
    const talk = _find(this.talks, item => item.id === id);
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ViewTalkController',
      template: viewTalkTemplate,
      clickOutsideToClose: true,
      locals: {talk},
      targetEvent: ev
    });
  }

  edit(id, ev) {
    ev.stopPropagation();
    const talk = this.getTalk(id);
    if (Number(talk.employee.id) !== this.me.employeeId) {
      return this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak uprawnień')
          .textContent('Nie możesz edytować wpisu, którego nie utworzyłeś.')
          .ariaLabel('Nie możesz edytować wpisu, którego nie utworzyłeś')
          .ok('Zamknij')
          .targetEvent(ev)
      );
    }

    this.$state.go('modules.talks.edit', {id});
  }

  remove(id, ev) {
    ev.stopPropagation();
    const talk = this.getTalk(id);
    if (Number(talk.employee.id) !== this.me.employeeId) {
      return this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak uprawnień')
          .textContent('Nie możesz usunąć wpisu, którego nie utworzyłeś.')
          .ariaLabel('Nie możesz usunąć wpisu, którego nie utworzyłeś')
          .ok('Zamknij')
          .targetEvent(ev)
      );
    }

    this.TalkService.delete({data: id}).then(() => {
      _remove(this.talks, talk => talk.id === id);
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto rozmowę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  getTalk(id) {
    return _find(this.talks, talk => talk.id === id);
  }
}

export const Talks = {
  bindings: {
    me: '<',
    talks: '<'
  },
  template,
  controller: TalksComponent
};
